const getStyledSuggestion = (suggestion: string, inputValue: string) => {
  const userInputLength = inputValue.length;
  return (
    <span>
      <b>{suggestion.substring(0, userInputLength)}</b>
      {suggestion.substring(userInputLength)}
    </span>
  );
};

export { getStyledSuggestion };
